import { getTransform } from "./qaConfig"

const getPOS_CRUD_Config ={
  ...getTransform("dk_pos_location_number_create_label"),
  ...getTransform("dk_pos_location_number_create_input"),

  ...getTransform("dk_pos_location_name_create_label"),
  ...getTransform("dk_pos_location_name_create_input"),

  ...getTransform("dk_pos_location_type_create_label"),
  ...getTransform("dk_pos_location_type_create_input"),

  ...getTransform("dk_pos_id_create_label"),
  ...getTransform("dk_pos_id_create_input"),

  ...getTransform("dk_pos_model_type_create_label"),
  ...getTransform("dk_pos_model_type_create_input"),
  ...getTransform("dk_pos_model_type_create_error"),

  ...getTransform("dk_pos_serial_number_create_label"),
  ...getTransform("dk_pos_serial_number_create_input"),
  ...getTransform("dk_pos_serial_number_create_error"),

  ...getTransform("dk_pos_vision_ai_create_label"),
  ...getTransform("dk_pos_vision_ai_create_input"),

  ...getTransform("dk_pos_product_delete_auth_label"),
  ...getTransform("dk_pos_product_delete_auth_input"),
  ...getTransform("dk_pos_product_delete_auth_input_label"),

  ...getTransform("dk_pos_pay_now_create_label"),
  ...getTransform("dk_pos_pay_now_create_input"),

  ...getTransform("dk_pos_pay_later_create_label"),
  ...getTransform("dk_pos_pay_later_create_input"),

  ...getTransform("dk_pos_pay_at_front_desk_create_label"),
  ...getTransform("dk_pos_pay_at_front_desk_create_input"),

  ...getTransform("dk_pos_auto_cancel_timeout_create_label"),
  ...getTransform("dk_pos_auto_cancel_timeout_create_input"),

  ...getTransform("dk_pos_loyalty_create_label"),
  ...getTransform("dk_pos_loyalty_create_input"),

  ...getTransform("dk_pos_discount_create_label"),
  ...getTransform("dk_pos_discount_create_input"),

  ...getTransform("dk_pos_add_more_products_create_label"),
  ...getTransform("dk_pos_add_more_products_create_input"),

  ...getTransform("dk_pos_preview_timeout_create_label"),
  ...getTransform("dk_pos_preview_timeout_create_input"),

  ...getTransform("dk_pos_cloud_connectivity_create_label"),
  ...getTransform("dk_pos_cloud_connectivity_create_input"),

  ...getTransform("dk_pos_local_connectivity_create_input"),
  ...getTransform("dk_pos_local_connectivity_create_error"),

  ...getTransform("dk_pos_select_clover_payment_id_create_label"),
  ...getTransform("dk_pos_select_clover_payment_id_create_input"),

  ...getTransform("dk_pos_data_collection_create_label"),
  ...getTransform("dk_pos_data_collection_create_input"),

  ...getTransform("dk_pos_auto_login_create_label"),
  ...getTransform("dk_pos_auto_login_create_input"),

  ...getTransform("dk_pos_save_create_Icon"),
  ...getTransform("dk_pos_cancel_create_Icon"),
  ...getTransform("dk_pos_edit_create_Icon"),


  //Edit

  ...getTransform("dk_pos_detailedpage_toggle_icon"),
 ...getTransform("dk_pos_location_number_edit_label"),
  ...getTransform("dk_pos_location_number_edit_input"),
  ...getTransform("dk_pos_location_number_edit_input_label"),

  ...getTransform("dk_pos_location_name_edit_label"),
  ...getTransform("dk_pos_location_name_edit_input"),
  ...getTransform("dk_pos_location_name_edit_input_label"),

  ...getTransform("dk_pos_location_type_edit_label"),
  ...getTransform("dk_pos_location_type_edit_input"),
  ...getTransform("dk_pos_location_type_edit_input_label"),

  ...getTransform("dk_pos_id_edit_label"),
  ...getTransform("dk_pos_id_edit_input_label"),

  ...getTransform("dk_pos_model_type_edit_label"),
  ...getTransform("dk_pos_model_type_edit_input"),
  ...getTransform("dk_pos_model_type_edit_error"),
  ...getTransform("dk_pos_model_type_edit_input_label"),

  ...getTransform("dk_pos_serial_number_edit_label"),
  ...getTransform("dk_pos_serial_number_edit_input"),
  ...getTransform("dk_pos_serial_number_edit_error"),
  ...getTransform("dk_pos_serial_number_edit_input_label"),

  ...getTransform("dk_pos_vision_ai_edit_label"),
  ...getTransform("dk_pos_vision_ai_edit_input"),
  ...getTransform("dk_pos_vision_ai_edit_input_label"),

  ...getTransform("dk_pos_detailed_product_delete_auth_label"),
  ...getTransform("dk_pos_detailed_product_delete_auth_input"),
  ...getTransform("dk_pos_detailed_product_delete_auth_input_label"),
  
  ...getTransform("dk_pos_pay_now_edit_label"),
  ...getTransform("dk_pos_pay_now_edit_input"),
  ...getTransform("dk_pos_pay_now_edit_input_label"),

  ...getTransform("dk_pos_pay_later_edit_label"),
  ...getTransform("dk_pos_pay_later_edit_input"),
  ...getTransform("dk_pos_pay_later_edit_input_label"),

  ...getTransform("dk_pos_pay_at_front_desk_edit_label"),
  ...getTransform("dk_pos_pay_at_front_desk_edit_input"),
  ...getTransform("dk_pos_pay_at_front_desk_edit_input_label"),

  ...getTransform("dk_pos_auto_cancel_timeout_edit_label"),
  ...getTransform("dk_pos_auto_cancel_timeout_edit_input"),
  ...getTransform("dk_pos_auto_cancel_timeout_edit_input_label"),

  ...getTransform("dk_pos_loyalty_edit_label"),
  ...getTransform("dk_pos_loyalty_edit_input"),
  ...getTransform("dk_pos_loyalty_edit_input_label"),

  ...getTransform("dk_pos_discount_edit_label"),
  ...getTransform("dk_pos_discount_edit_input"),
  ...getTransform("dk_pos_discount_edit_input_label"),

  ...getTransform("dk_pos_add_more_products_edit_label"),
  ...getTransform("dk_pos_add_more_products_edit_input"),
  ...getTransform("dk_pos_add_more_products_edit_input_label"),

  ...getTransform("dk_pos_preview_timeout_edit_label"),
  ...getTransform("dk_pos_preview_timeout_edit_input"),
  ...getTransform("dk_pos_preview_timeout_edit_input_label"),

  ...getTransform("dk_pos_cloud_connectivity_edit_label"),
  ...getTransform("dk_pos_cloud_connectivity_edit_input"),
  ...getTransform("dk_pos_cloud_connectivity_edit_input_label"),

  ...getTransform("dk_pos_select_clover_payment_id_edit_label"),
  ...getTransform("dk_pos_select_clover_payment_id_edit_input"),
  ...getTransform("dk_pos_select_clover_payment_id_edit_input_label"),

    ...getTransform("dk_pos_clover_disassociate_edit_input_label"),

  ...getTransform("dk_pos_data_collection_edit_label"),
  ...getTransform("dk_pos_data_collection_edit_input"),
  ...getTransform("dk_pos_data_collection_edit_input_label"),

  ...getTransform("dk_pos_auto_login_edit_label"),
  ...getTransform("dk_pos_auto_login_edit_input"),
  ...getTransform("dk_pos_auto_login_edit_input_label"),

  ...getTransform("dk_pos_detailed_cancel_Icon"),
  ...getTransform("dk_pos_detailed_save_Icon"),
  ...getTransform("dk_pos_detailed_edit_Icon"),

  // Edge Device Create

 ...getTransform("dk_pos_edge_device_id_create_label"),
  ...getTransform("dk_pos_edge_device_id_create_input_label"),

  ...getTransform("dk_pos_edge_device_ip_address_create_label"),
  ...getTransform("dk_pos_edge_device_ip_address_create_input"),
  ...getTransform("dk_pos_edge_device_ip_address_create_error"),
  ...getTransform("dk_pos_edge_device_ip_address_create_input_label"),

  ...getTransform("dk_pos_edge_device_mac_address_create_label"),
  ...getTransform("dk_pos_edge_device_mac_address_create_input"),
  ...getTransform("dk_pos_edge_device_mac_address_create_error"),
  ...getTransform("dk_pos_edge_device_mac_address_create_input_label"),

  ...getTransform("dk_pos_edge_device_serial_number_create_label"),
  ...getTransform("dk_pos_edge_device_serial_number_create_input"),
  ...getTransform("dk_pos_edge_device_serial_number_create_error"),
  ...getTransform("dk_pos_edge_device_serial_number_create_input_label"),

    ...getTransform("dk_pos_edge_device_create_cancel_Icon"),
    ...getTransform("dk_pos_edge_device_create_save_Icon"),


// Edge Device Edit

 ...getTransform("dk_pos_edge_device_id_edit_label"),
  ...getTransform("dk_pos_edge_device_id_edit_input_label"),

  ...getTransform("dk_pos_edge_device_ip_address_edit_label"),
  ...getTransform("dk_pos_edge_device_ip_address_edit_input"),
  ...getTransform("dk_pos_edge_device_ip_address_edit_error"),
  ...getTransform("dk_pos_edge_device_ip_address_edit_input_label"),

  ...getTransform("dk_pos_edge_device_mac_address_edit_label"),
  ...getTransform("dk_pos_edge_device_mac_address_edit_input"),
  ...getTransform("dk_pos_edge_device_mac_address_edit_error"),
  ...getTransform("dk_pos_edge_device_mac_address_edit_input_label"),

   ...getTransform("dk_pos_edge_device_serial_number_edit_label"),
  ...getTransform("dk_pos_edge_device_serial_number_edit_input"),
  ...getTransform("dk_pos_edge_device_serial_number_edit_error"),
  ...getTransform("dk_pos_edge_device_serial_number_edit_input_label"),

   ...getTransform("dk_pos_edge_device_uuid_edit_label"),
  ...getTransform("dk_pos_edge_device_uuid_edit_input"),
  ...getTransform("dk_pos_edge_device_uuid_edit_input_label"),

   ...getTransform("dk_pos_edge_device_status_edit_label"),
  ...getTransform("dk_pos_edge_device_status_edit_input"),
  ...getTransform("dk_pos_edge_device_status_edit_error"),
  ...getTransform("dk_pos_edge_device_status_edit_input_label"),

    ...getTransform("dk_pos_edge_device_edit_cancel_Icon"),
    ...getTransform("dk_pos_edge_device_edit_save_Icon"),
    ...getTransform("dk_pos_edge_device_edit_Icon"),
    ...getTransform("dk_pos_list_search_locations_input"),

    ...getTransform("dk_pos_inventory_tracking_create_label"),
    ...getTransform("dk_pos_inventory_tracking_create_input"),
    ...getTransform("dk_pos_inventory_tracking_edit_label"),
    ...getTransform("dk_pos_inventory_tracking_edit_input"),
    ...getTransform("dk_pos_inventory_tracking_edit_input_label"),

}

const doPOSAddOnTestId = (testIdValue = "null") => {
    let testId = {}
    if (testIdValue) {
      testId["data-testid"] = `dk-pos-config-${testIdValue}`
    }
  
    return testId
}


export {getPOS_CRUD_Config,doPOSAddOnTestId}
